import React, { useMemo } from 'react';
import classnames from 'classnames';

import styles from '../AgeVerificationOverlay/AgeVerificationOverlay.module.css';
import { UserContext } from '../../context';


function SfwImage({ overlayedImage, sfwImage, nsfwImage, alt, ...rest }) {
  const user = React.useContext(UserContext);
  const sfwImageExists = sfwImage && !sfwImage?.includes('null');
  const image = useMemo(() => {
    if (!sfwImageExists) {
      return nsfwImage;
    }

    return sfwImage;
  }, [sfwImageExists, sfwImage, nsfwImage]);

  if (user?.sfw) {
    return (
      <React.Fragment>
        {overlayedImage && !sfwImageExists && (
          <img
            alt="Members Only"
            className={classnames(
              styles.membersOnlyOverlay,
              'unblurred nn-logo'
            )}
            src={overlayedImage}
          />
        )}
        <img
          {...rest}
          alt={alt}
          className={classnames('unblurred nn-logo', rest.className)}
          src={image}
          style={{
            ...(!sfwImageExists && { filter: 'blur(10px)' }),
            ...rest.style,
          }}
        />
      </React.Fragment>
    );
  }

  return <img alt={alt} src={nsfwImage} {...rest} />;
}

export default SfwImage;
